// 거르개 알약 — 목록 위에서 보는 범위를 좁히는 단추. VM 화면과 팀 화면이 같은 모양을 쓰므로
// 문자열은 여기 한 곳에만 있다(F-49). 켜진 것은 바탕이 서고 꺼진 것은 글자만 있다.
export const PILL = 'rounded-full border px-3 py-1 text-[12px] disabled:opacity-50'
export const PILL_ON = 'bg-surface-2 text-foreground'
export const PILL_OFF = 'text-muted-foreground hover:text-foreground'

export const pill = (on: boolean) => `${PILL} ${on ? PILL_ON : PILL_OFF}`
